import angular from 'angular';
import translate from 'angular-translate';

function splitTranslationWithLink($translate) {
    'ngInject';
    return function (key, params) {
        let message = $translate.instant(key, params);
        let translations = {};
        let transArray = message.split(params.link_start);

        translations[key] = transArray[0];
        if(transArray[1]){
            transArray = transArray[1].split(params.link_end);
            translations[key + '_end'] = transArray[1];
        }
   
        translations[key + '_link'] = transArray[0];
     
        return translations;
    };
}

const splitTranslationWithLinkFilter = angular.module('st.filters.splitTranslationWithLink', [
    translate
])
    .filter('splitTranslationWithLink', splitTranslationWithLink)
    .name;

export default splitTranslationWithLinkFilter;


// WEBPACK FOOTER //
// ./client/app/common/filters/extractAndCreateTranslationLink.js